import axios from 'axios';
import * as Sentry from '@sentry/react';
import {
  resolveApiBaseUrl,
  STATIC_API_URL,
  PREVIEW_API_LOOKUP,
  PREVIEW_PR,
} from './previewApiLookup';

const api = axios.create({
  baseURL: PREVIEW_API_LOOKUP ? '' : STATIC_API_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(async (config) => {
  if (PREVIEW_API_LOOKUP && !config.baseURL) {
    if (!PREVIEW_PR) {
      throw new Error('Preview API lookup enabled, but VITE_PREVIEW_PR_NUMBER is missing.');
    }
    config.baseURL = await resolveApiBaseUrl({ prNumber: PREVIEW_PR });
  }
  const token = sessionStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (PREVIEW_PR) {
    config.headers['X-Preview-PR'] = PREVIEW_PR;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.removeItem('token');
      window.location.href = '/login';
    } else if (
      error.response?.status === 402 &&
      error.response?.data?.error === 'billing_lapsed' &&
      !window.location.pathname.startsWith('/billing')
    ) {
      window.location.href = '/billing/locked';
    }
    Sentry.captureException(error);
    return Promise.reject(error);
  },
);

export default api;
